import DeleteTermsAndCondition from "@/v2/api/terms-and-conditions/Delete";
import DeleteButton from "../general/Delete";

export default function TermsAndConditionsDeleteButton({
    id,
    isInside = false,
}: {
    id: string;
    isInside?: boolean;
}) {
    return (
        <DeleteButton
            id={id}
            deleteFn={DeleteTermsAndCondition}
            queryKey={["terms-and-conditions"]}
            title="Delete Terms And Condition Template"
            description="Are you sure you want to delete this terms and condition template ? This action cannot be undone. Click delete to confirm."
            successTitle="Terms And Condition Template Successfully"
            isInside={isInside}
        />
    );
}
